import { Base, createApp } from '@studiometa/js-toolkit';
import { AccordionItem, Panel } from '@studiometa/ui';
import MobileMenu from './components/MobileMenu.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      AccordionItem,
      MobileMenu,
      Panel,
    },
  };
}

export default createApp(App, {
  root: document.documentElement,
  screens: {
    '2xs': '0rem',
    xs: '30rem',
    s: '40rem',
    m: '48rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
